import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
const a = {
  name: e.hungarian,
  global: {
    undo: "Visszavonás",
    redo: "Újra",
    confirm: "megerősít",
    clear: "Egyértelmű",
    more: "több",
    cancel: "Megszünteti"
  },
  Popconfirm: {
    positiveText: "megerősít",
    negativeText: "Megszünteti"
  },
  Cascader: {
    placeholder: "Kérlek, válassz",
    loading: "Betöltés",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Egyértelmű",
    now: "Most",
    confirm: "megerősít",
    selectTime: "Válassza az Idő lehetőséget",
    selectDate: "Válassza a Dátum lehetőséget",
    datePlaceholder: "Válassza a Dátum lehetőséget",
    datetimePlaceholder: "Válassza a Dátum és idő lehetőséget",
    monthPlaceholder: "Válassz hónapot",
    yearPlaceholder: "Válassza az Évet",
    quarterPlaceholder: "Válassza a Negyed lehetőséget",
    startDatePlaceholder: "Kezdő dátum",
    endDatePlaceholder: "Befejezés dátuma",
    startDatetimePlaceholder: "Kezdés dátuma és időpontja",
    endDatetimePlaceholder: "Befejezés dátuma és időpontja",
    startMonthPlaceholder: "Kezdő hónap",
    endMonthPlaceholder: "Hónap vége",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Ma"
  },
  DataTable: {
    checkTableAll: "Válassza ki az összeset a táblázatból",
    uncheckTableAll: "Törölje az összes kijelölést a táblázatban",
    confirm: "Megerősít",
    clear: "Egyértelmű",
    apply: "Alkalmaz",
    filters: "Szűrők",
    sort: "Fajta"
  },
  LegacyTransfer: {
    sourceTitle: "Forrás",
    targetTitle: "Cél"
  },
  Transfer: {
    selectAll: "Mindet kiválaszt",
    unselectAll: "Minden kijelölés megszüntetése",
    clearAll: "Egyértelmű"
  },
  Empty: {
    description: "Nincs adat"
  },
  Select: {
    placeholder: "Kérlek, válassz"
  },
  TimePicker: {
    placeholder: "Válassza az Idő lehetőséget",
    positiveText: "rendben",
    negativeText: "Megszünteti",
    now: "Most"
  },
  Pagination: {
    goto: "Menj",
    selectionSuffix: "oldalon",
    next: "Következő",
    previous: "Előző"
  },
  DynamicTags: {
    add: "Hozzáadás"
  },
  Log: {
    loading: "Betöltés"
  },
  Input: {
    placeholder: "Kérem írja be"
  },
  InputNumber: {
    placeholder: "Kérem írja be"
  },
  DynamicInput: {
    create: "Teremt"
  },
  ThemeEditor: {
    title: "Témaszerkesztő",
    clearAllVars: "Minden változó törlése",
    clearSearch: "Keresés törlése",
    filterCompName: "Szűrőkomponens neve",
    filterVarName: "Szűrőváltozó neve",
    import: "Importálás",
    export: "Export",
    restore: "Visszaállítás alapértelmezettre"
  },
  Image: {
    tipPrevious: "Előző kép (←)",
    tipNext: "Következő kép (→)",
    tipCounterclockwise: "Óramutató járásával ellentétes irányban",
    tipClockwise: "Óramutató járásával megegyező",
    tipZoomOut: "Kicsinyítés",
    tipZoomIn: "Nagyítás",
    tipClose: "Bezárás (Esc)",
    tipOriginalSize: "Nagyítás az eredeti méretre"
  },
  SortFilter: {
    heading: "Rendezés és szűrők",
    sortHeading: "Rendezés",
    newestFirst: "Legújabb első",
    oldestFirst: "A legrégebbi első",
    ascending: "Asc",
    descending: "Desc",
    aToZ: "A-Z",
    // Don't translate,
    zToA: "Z-A",
    // Don't translate,
    apply: "Alkalmaz",
    clear: "Egyértelmű",
    cancel: "Megszünteti",
    filters: "Szűrők"
  },
  IconPicker: {
    noMatchingFound: "Nem található egyező találat"
  },
  Spacing: {
    margin: "Margó",
    padding: "Kitöltés",
    reset: "Visszaállítás",
    errorMsg: "A megadott érték érvénytelen."
  },
  BrandColorPicker: {
    brandColors: "Márkaszínek",
    noBrandColors: "Még nem adtál hozzá márkaszíneket.",
    getStarted: "Kezdd el",
    add: "Hozzáad",
    default: "Alapértelmezett"
  }
};
export {
  a as hu
};
